import { produce } from 'immer';

import { UpdateInternalMarketerGridOffset } from '../../../actions/marketer/internal/updateInternalMarketerGridOffset';
import { MarketerState } from '../../../typings/marketers';

export function updateInternalMarketerGridOffset(
    state: MarketerState,
    action: UpdateInternalMarketerGridOffset
): MarketerState {
    return produce(state, draft => {
        draft.gridOffset = action.offset;
    });
}
